var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3332 3.99902C16.3453 3.99902 9.84668 10.4976 9.84668 18.4854C9.84668 28.3986 22.8106 42.9516 23.3626 43.5662C23.881 44.1436 24.7862 44.1426 25.3038 43.5662C25.8556 42.9516 38.8196 28.3986 38.8196 18.4854C38.8194 10.4976 32.321 3.99902 24.3332 3.99902ZM24.3332 25.774C20.3142 25.774 17.0447 22.5044 17.0447 18.4854C17.0447 14.4665 20.3143 11.197 24.3332 11.197C28.352 11.197 31.6216 14.4666 31.6216 18.4855C31.6216 22.5044 28.352 25.774 24.3332 25.774Z",
    fill: "#00009F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c450e7a0f7aa3ec478d3407bd340bec1.svg";
export { ForwardRef as ReactComponent };